import(/* webpackMode: "eager", webpackExports: ["PrismeProvider"] */ "/builds/PortailVente/portailvente_web_wall/nextweb/node_modules/@bytel/logger-nextjs/dist/client.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/node_modules/@bytel/trilogy-styles/dist/default/trilogy.css");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/assets/styles/custo.css");
;
import(/* webpackMode: "eager", webpackExports: ["TrackingScript"] */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/components/tracking-script.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Provider"] */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/providers/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryClientProvider"] */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/providers/query-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VirtualCartProvider"] */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/providers/virtual-cart.tsx");
